import { IBaseArgument } from './IBaseArgument';

export const generateVariableDefinitions = (args: IBaseArgument[]): string => {
    const variables: { [key: string]: string } = {};
    args.forEach((a) => {
        variables[a.name] = `$${ a.name }: ${a.graphQLType}${a.isNonNullable ? '!' : ''}`;
    });

    return Object.keys(variables).map((v) => {
        return variables[v];
    }).join('\n');
};

export const generateVariableParams = (args: IBaseArgument[]): string => {
    const variables: { [key: string]: string } = {};
    args.forEach((a) => {
        variables[a.name] = `${a.name}: $${a.name}`;
    });

    return Object.keys(variables).map((v) => {
        return variables[v];
    }).join('\n');
};

export const generateVariablesObject = (args: IBaseArgument[]): { [key: string]: any } => {
    const variables: { [key: string]: any } = {};
    args.map((a) => {
        variables[a.name] = a.value;
    });
    return variables;
}
